import React from "react";
import {BrowserRouter, Routes, Route, Link} from 'react-router-dom';
import '@fontsource/roboto/400.css';
import './App.css';
import './bootstrap-grid.min.css';
import Footer from './components/Footer';
import Header from './components/Header';
import Register from './components/Register';
import Login from './components/Login';
import Logout from './components/Logout';
import Dashboard from './components/Dashboard';
import DashboardAdmin from './components/DashboardAdmin';
import Pedidos from './components/Pedidos';
import NuevoPedido from './components/NuevoPedido';
import NuevoPedido_test from './components/NuevoPedido_test';
import Envios from './components/Envios';
import EnviosAdmin from './components/EnviosAdmin';
import EnvioCorrecto from './components/EnvioCorrecto';
import EnvioCorrecto_test from './components/EnvioCorrecto_test';
import Envioerror from './components/Envioerror';
import EnvioPaquete from './components/EnvioPaquete';
import GuiaImprimir from './components/Guia_imprimir';
import PedidoMasivo from './components/PedidoMasivo';
import EnvioExcelMasivoItalika from './components/EnvioExcelMasivoItalika';
import DashboardItalika from './components/DashboardItalika';
import DashboardAdminItalika from './components/DashboardAdminItalika';
//import DashboardAdminItalika_Test from './components/DashboardAdminItalika_Test';
import EnvioerrorMasivoItalika from './components/EnvioerrorMasivoItalika';
import EnvioCorrectoMasivoItalika from './components/EnvioCorrectoMasivoItalika';


//<Route path="/dashboardAdminItalika_Test" element={<DashboardAdminItalika_Test />} />
            

function App() {
  return (
    <div>
      <Header />
        <BrowserRouter>
          <Routes>
            <Route index element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboardAdmin" element={<DashboardAdmin />} />
            <Route path="/Pedidos" element={<Pedidos />} />
            <Route path="/NuevoPedido" element={<NuevoPedido />} />
            <Route path="/NuevoPedido_test" element={<NuevoPedido_test />} />
            <Route path="/Envios" element={<Envios />} />
            <Route path="/EnviosAdmin" element={<EnviosAdmin />} />
            <Route path="/EnvioCorrecto" element={<EnvioCorrecto />} />
            <Route path="/EnvioCorrecto_test" element={<EnvioCorrecto_test />} />
            <Route path="/Envioerror" element={<Envioerror />} />
            <Route path="/EnvioPaquete" element={<EnvioPaquete />} />
            <Route path="/GuiaImprimir" element={<GuiaImprimir />} />
            <Route path="/PedidoMasivo" element={<PedidoMasivo />} />
            <Route path="/EnvioExcelMasivoItalika" element={<EnvioExcelMasivoItalika />} />
            <Route path="/dashboardItalika" element={<DashboardItalika />} />
            <Route path="/dashboardAdminItalika" element={<DashboardAdminItalika />} />
            <Route path="/EnvioerrorMasivoItalika" element={<EnvioerrorMasivoItalika />} />
            <Route path="/EnvioCorrectoMasivoItalika" element={<EnvioCorrectoMasivoItalika />} />            
          </Routes>
        </BrowserRouter>
      <Footer />
    </div>
  );
}

export default App;